import { render, staticRenderFns } from "./mobileTabContent.vue?vue&type=template&id=e6221452&"
import script from "./mobileTabContent.vue?vue&type=script&lang=js&"
export * from "./mobileTabContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports